TPS.PartnerRegistration = {
    pnlMessage: null,
    pnlApplication: null,
    btnApplicationSubmit: null,

    inputs: {},

    memberProfile: {},

    type: 'NEW',

    init: function () {
        TPS.PartnerRegistration.pnlMessage = document.getElementById('pnlMessage');
        TPS.PartnerRegistration.pnlApplication = document.getElementById('pnlApplication');
        TPS.PartnerRegistration.btnApplicationSubmit = document.getElementById('applicationSubmit');
        TPS.PartnerRegistration.companyName = document.getElementById('applicationCompanyName');
        TPS.PartnerRegistration.companyPlanName = document.getElementById('companyPlanPartnerName');
        TPS.PartnerRegistration.inputs.companyCode = document.getElementById('applicationCompanyCode');
        TPS.PartnerRegistration.inputs.firstName = document.getElementById('applicationFirstName');
        TPS.PartnerRegistration.inputs.lastName = document.getElementById('applicationLastName');
        TPS.PartnerRegistration.inputs.email = document.getElementById('applicationEmail');
        TPS.PartnerRegistration.inputs.pwd = document.getElementById('applicationPwd');
        TPS.PartnerRegistration.inputs.pwdConfirm = document.getElementById('applicationPwdConfirm');
        TPS.PartnerRegistration.inputs.address = document.getElementById('applicationAddress');
        TPS.PartnerRegistration.inputs.city = document.getElementById('applicationCity');
        TPS.PartnerRegistration.inputs.state = document.querySelector('#applicationState select');
        TPS.PartnerRegistration.inputs.zipCode = document.getElementById('applicationZipCode');
        TPS.PartnerRegistration.inputs.country = document.querySelector('#applicationCountry select');
        TPS.PartnerRegistration.inputs.phone = document.getElementById('applicationPhone');
        TPS.PartnerRegistration.inputs.mobilePhone = document.getElementById('applicationMobilePhone');
        TPS.PartnerRegistration.inputs.contactMethod = document.getElementById('applicationContactMethod');
        TPS.PartnerRegistration.inputs.optIn = document.getElementById('applicationOptIn');

        var hasError = TPS.Util.getUrlParameter('error');

        if (hasError == 1) {
            var message = TPS.Util.getUrlParameter('message');
            TPS.PartnerRegistration.displayMessage(message);
        } else {
            if (TPS.PartnerRegistration.pnlApplication) {
                TPS.Util.loadWebserviceJS('CMSApp.AV.API.Membership');
                if (TPS.Util.getUrlParameter('user') === 'true') {
                    TPS.PartnerRegistration.type = 'EXISTING';
                }
                TPS.PartnerRegistration.handleUser();
            } else {
                var message = 'There was an error in preparing the form: ';
                var messageParam = TPS.Util.getUrlParameter('message');
                if (messageParam) {
                    message += messageParam;
                }
                TPS.PartnerRegistration.displayMessage(message);
            }
        }
    },

    displayMessage: function (msg) {
        TPS.PartnerRegistration.pnlMessage.classList.remove('hide');
        TPS.PartnerRegistration.pnlMessage.querySelector('#pnlMessageText').innerHTML = msg;
    },

    handleUser: function () {
        CMSApp.AV.API.Membership.MyProfile(function (d) {
            console.log(d);
            TPS.PartnerRegistration.storeProfile(d);
            TPS.PartnerRegistration.populateFields();
            TPS.PartnerRegistration.showApplication();

        }, TPS.Util.displayError);
    },

    storeProfile: function (d) {
        TPS.PartnerRegistration.memberProfile.AvailableRelationships = d.Object.AvailableRelationships;
        TPS.PartnerRegistration.memberProfile.AvailableVehicles = d.Object.AvailableVehicles;
        TPS.PartnerRegistration.memberProfile.ProgramName = d.Object.ProgramName;
        TPS.PartnerRegistration.memberProfile.Firstname = d.Object.Firstname;
        TPS.PartnerRegistration.memberProfile.Lastname = d.Object.Lastname;
        TPS.PartnerRegistration.memberProfile.Email = d.Object.Email;
        TPS.PartnerRegistration.memberProfile.MobilePhone = d.Object.MobilePhone;
        TPS.PartnerRegistration.memberProfile.Phone = d.Object.Phone;
        TPS.PartnerRegistration.memberProfile.Address = d.Object.Address;
        TPS.PartnerRegistration.memberProfile.optIn = d.Object.OptIn;
        TPS.PartnerRegistration.memberProfile.preferredContactMethod = d.Object.ContactMethod;
        TPS.PartnerRegistration.memberProfile.Company = d.Object.Company;
    },

    populateFields: function () {        
        TPS.PartnerRegistration.companyName.innerText = TPS.PartnerRegistration.memberProfile.Company.Name;
        TPS.PartnerRegistration.companyPlanName.innerText = TPS.PartnerRegistration.memberProfile.ProgramName;

        TPS.PartnerRegistration.inputs.companyCode.value = TPS.PartnerRegistration.memberProfile.Company.Code;
        TPS.PartnerRegistration.inputs.firstName.value = TPS.PartnerRegistration.memberProfile.Firstname;
        TPS.PartnerRegistration.inputs.lastName.value = TPS.PartnerRegistration.memberProfile.Lastname;
        TPS.PartnerRegistration.inputs.email.value = TPS.PartnerRegistration.memberProfile.Email;

        if (TPS.PartnerRegistration.memberProfile.Address !== null) {
            TPS.PartnerRegistration.inputs.address.value = TPS.PartnerRegistration.memberProfile.Address.Address;
            TPS.PartnerRegistration.inputs.city.value = TPS.PartnerRegistration.memberProfile.Address.City;
            TPS.PartnerRegistration.inputs.state.value = TPS.PartnerRegistration.memberProfile.Address.State;
            TPS.PartnerRegistration.inputs.country.value = TPS.PartnerRegistration.memberProfile.Address.Country;
            TPS.PartnerRegistration.inputs.zipCode.value = TPS.PartnerRegistration.memberProfile.Address.ZipCode;
        }

        TPS.PartnerRegistration.inputs.phone.value = TPS.PartnerRegistration.memberProfile.Phone;
        TPS.PartnerRegistration.inputs.mobilePhone.value = TPS.PartnerRegistration.memberProfile.MobilePhone;

        var contactMethods = TPS.PartnerRegistration.inputs.contactMethod.querySelectorAll('input');
        Array.prototype.forEach.call(contactMethods, function (el, i) {
            if (el.value == TPS.PartnerRegistration.memberProfile.preferredContactMethod) {
                el.checked = true;
            }
        });

        TPS.PartnerRegistration.inputs.optIn.checked = TPS.PartnerRegistration.memberProfile.optIn;
    },

    showApplication: function () {
        TPS.Forms.setupClientValidation('#pnlApplication');
        TPS.PartnerRegistration.pnlApplication.classList.remove('hide');
        TPS.PartnerRegistration.btnApplicationSubmit.addEventListener('click', TPS.PartnerRegistration.submitApplication);
    },

    submitApplication: function (e) {
        e.preventDefault();
        TPS.Forms.resetMessageBlock('#error-callout');

        if (TPS.Forms.validator.checkForm() && !TPS.PartnerRegistration.btnApplicationSubmit.classList.contains('submitting')) {
            TPS.PartnerRegistration.setSubmitButtonState(true);

            var vals = TPS.Forms.getFormVals('#pnlApplication');

            // force state and country from uniselector
            vals['applicationState'] = TPS.PartnerRegistration.inputs.state.value;
            vals['applicationCountry'] = TPS.PartnerRegistration.inputs.country.value;

            // get the current page culture code from
            // kentico lng hidden input
            vals['applicationCultureCode'] = $('#lng').val() === 'en-US' ? 'en-US' : vals.rdlLanguage;

            CMSApp.AV.API.Membership.SaveRegister(
                //(string address, string city, int stateID, string zipcode, string phoneNumber, string mobilePhoneNumer, bool optIn, string contactMethod, string password, string confirmPassword)
                vals.applicationAddress,
                vals.applicationCity,
                parseInt(vals.applicationState, 10),
                vals.applicationZipCode,
                vals.applicationPhone,
                vals.applicationMobilePhone,
                vals.applicationOptIn,
                vals.applicationContactMethod,
                vals.applicationPwd,
                vals.applicationPwdConfirm,
                vals.applicationCultureCode,
                success,
                fail
            );
        }

        function success(data) {
            if (data.Success) {
                console.log(data);
                if (TPS.PartnerRegistration.type === 'EXISTING') {
                    window.location.href = '/Public/RegisterNew/Welcome/';
                } else {
                    window.location.href = '/Public/RegisterNew/Thanks/';
                }
            } else {
                TPS.Forms.scrollToMessages(data.ErrorMessages, false, '#error-callout', '.hidden-magellan-error', false);
            }
            TPS.PartnerRegistration.setSubmitButtonState(false);
        }

        function fail(data) {
            console.log(data);
            TPS.Forms.scrollToMessages(data._statusCode + " : " + data._message, true, '#error-callout', '.hidden-magellan-error', true);
            TPS.PartnerRegistration.setSubmitButtonState(false);
        } 
    },

    updateFlyout: function () {
        var flyOut = jQuery('#member-flyout');
        var flyOut = document.getElementById('member-flyout');

        if (flyOut) {
            var address = '<br/>' + TPS.PartnerRegistration.memberProfile.Address.Address;
            address += '<br/>' + TPS.PartnerRegistration.memberProfile.Address.City;
            address += ', ' + TPS.PartnerRegistration.memberProfile.Address.State;
            address += '<br/>' + TPS.PartnerRegistration.memberProfile.Address.ZipCode + '<br/>';

            flyOut.querySelector('.name-wrapper').innerHTML = TPS.PartnerRegistration.memberProfile.Firstname + ' ' + TPS.PartnerRegistration.memberProfile.Lastname;
            flyOut.querySelector('.address-wrapper').innerHTML = address;
            flyOut.querySelector('.tel-wrapper').innerHTML = TPS.PartnerRegistration.memberProfile.Phone;
            flyOut.querySelector('.email-wrapper-link').innerHTML = TPS.PartnerRegistration.memberProfile.Email;
            flyOut.querySelector('.email-wrapper-link').setAttribute('href', 'mailto:' + TPS.PartnerRegistration.memberProfile.Email);
        }
    },

    setSubmitButtonState: function (isSubmitting) {
        if (isSubmitting === true) {
            TPS.PartnerRegistration.btnApplicationSubmit.classList.add('submitting');
            TPS.PartnerRegistration.btnApplicationSubmit.innerHTML += TPS.Util.submitSpinner;
            TPS.PartnerRegistration.btnApplicationSubmit.disabled = true;
        } else {
            TPS.PartnerRegistration.btnApplicationSubmit.removeChild(TPS.PartnerRegistration.btnApplicationSubmit.querySelector('.icon'));
            TPS.PartnerRegistration.btnApplicationSubmit.classList.remove('submitting');
            TPS.PartnerRegistration.btnApplicationSubmit.disabled = false;
        }
    }
}
